module.exports = __webpack_public_path__ + "static/media/tree-large.7ca9bca1.svg";